<template>
  <div>
    <b-overlay :show="loading">
      <b-container fluid>
        <span 
          v-if="etapyDvigeniya"
          @click="visible = 'etapy'"
          :class="visible === 'etapy' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Этапы движения</span>
      </b-container>

      <div v-show="visible === 'etapy'">
        <b-card>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="name_of_cargo">Маршрут</label>
                  </b-col>
                  <b-col sm="10">
                    <b-list-group horizontal="md" class="d-flex">
                      <b-list-group-item 
                        class="b-group-item-end" 
                        style="width: 50%"
                        :variant="variantByTwoDays(editedData['pogruzka_gruza_plan'], editedData['pogruzka_gruza_fact'])"
                      >
                        <div>
                          <template v-if="editedData.mesto_pogruzki_gorod && editedData.mesto_pogruzki_street">
                            <span class="small-description">адрес погрузки</span>
                            {{ editedData.mesto_pogruzki_gorod }}, {{ editedData.mesto_pogruzki_street }}
                          </template>
                          <template v-else>
                            {{ '<Здесь будет адрес погрузки>' }}
                          </template>
                        </div>
                        <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['pogruzka_gruza_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['pogruzka_gruza_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div>
                      </b-list-group-item>

                      <b-list-group-item 
                        class="b-group-item-end" 
                        style="width: 50%"
                        :variant="variantByTwoDays(editedData['dostavka_plan'], editedData['dostavka_fact'])"
                      >
                        <div>
                          <template v-if="editedData.address_of_unloading_town && editedData.address_of_unloading_street">
                            <span class="small-description">адрес выгрузки</span>
                            {{ editedData.address_of_unloading_town }}, {{ editedData.address_of_unloading_street }}
                          </template>
                          <template v-else>
                            {{ '<Здесь будет адрес выгрузки>' }}
                          </template>
                        </div>
                        <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['dostavka_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['dostavka_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div>
                      </b-list-group-item>
                    </b-list-group>                    
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import {
  constantsAllReferenceProperties,
  dateHelpers,
  dataHelpers
} from '@/mixins';

export default {
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    saveMode: {
      type: Boolean,
      default: false,
    },
    detailedItem: {
      type: Object,
      required: true,
    },
    filteredDocs: {
      type: Array,
      required: true,
    },
    etapyDvigeniya: {
      type: Boolean,
      default: true,
    },
    defaultVisible: {
      type: String,
      default: 'etapy',
    },
  },
  mixins: [
    constantsAllReferenceProperties,
    dateHelpers,
    dataHelpers
  ],
  components: {},
  computed: {
    obshee_transitnoe_vremya() {
      if (!this.editedData['pogruzka_gruza_fact'] || !this.editedData['dostavka_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['pogruzka_gruza_fact'], this.editedData['dostavka_fact']);
      return transitnoe_vremya == '0 дней' ? '1 день' : transitnoe_vremya;
    }
  },
  watch: {
    obshee_transitnoe_vremya(value) {
      this.editedData['obshee_transitnoe_vremya'] = value;
    }
  },
  data() {
    return {
      loading: false,
      localEditMode: false,
      visible: 'etapy',
      editedData: {
        "0": { value: '' },
        "1": { value: '' },
        name_of_cargo: '',
        import_export: 'Импорт',
        number_of_places: 0,
        weight: 0,
        volume: 0,
        cargo_sender_name: '',
        address_g_o: '',
        mesto_pogruzki_oblast: '',
        mesto_pogruzki_gorod: '',
        mesto_pogruzki_street: '',        
        contact_name_on_shipment: '',
        cargo_recipient_company_id: null,
        inn_g_p: '',
        kpp_g_p: '',
        address_g_p: '',
        address_of_unloading_oblast: '',
        address_of_unloading_town: '',
        address_of_unloading_street: '',
        contact_name_on_unloading: '',

        perevozchik_id: null,
        perevozchik_name: '',
        perevozchik_inn: '',
        perevozchik_uridicheskiy_address: '',

        nomer_of_tyagach: '',
        nomer_of_pricep: '',
        marka_of_tyagach: '',
        marka_of_pricep: '',

        voditel_fio: '',
        voditel_passport: '',
        voditel_vu: '',

        pogruzka_gruza_plan: '',
        pogruzka_gruza_fact: '',

        dostavka_plan: '',
        dostavka_fact: '',
        obshee_transitnoe_vremya: ''
      },
    };
  },
  watch: {
    editMode: {
      handler(value) {
        this.localEditMode = value;
      },
      immediate: true
    },
    saveMode: {
      handler(value) {
        if (value == true) {
          this.$emit('updateData', this.editedData);
        }
      },
      immediate: true
    },
    detailedItem: {
      handler(data) {
        this.editedData = this.deepMergeSafeFirst(JSON.parse(JSON.stringify(data.data)), JSON.parse(JSON.stringify(this.editedData)));
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    setReferenceValue(value, reference_id, index) {
      this.editedData[index] = value;
    },  
    setCompanyRecipientOfOrder(value, element) {
      this.editedData['cargo_recipient_company_id'] = value;
      this.editedData['inn_g_p'] = element.inn;
      this.editedData['kpp_g_p'] = element.kpp;
      this.editedData['address_g_p'] = element.address;
    },
    setCompanyPerevozchikOfOrder(value, element) {
      this.editedData['perevozchik_id'] = value;
      this.editedData['perevozchik_name'] = element.name;
      this.editedData['perevozchik_inn'] = element.inn;
      this.editedData['perevozchik_uridicheskiy_address'] = element.address;
    },
    changeSelectedDoc(doc) {
      this.editedData[0].value = doc.name;
      this.editedData[1].value = doc.date_of_document;
    },    
  },

  mounted() {
    this.visible = this.defaultVisible;
  },
};
</script>
<style scoped>
.custom-select {
  height: 34px !important;
  border-radius: 3px !important;
  padding: 1px 8px;
}
.small-description {
  line-height: 11px;
}
.b-group-item-end {
  display: flex !important;
  justify-content: space-between !important;
}

.b-group-item-end b {
  text-transform: none;
}
</style>